import React, { useEffect } from 'react'
import gmbanner from "../../assets/imgs/grants-management-through-automation.webp"
// import './css/GrantsManagement.css'
const GrantsManagement = () => {

    useEffect(() => {
        const violation = document.getElementById("top-menu");
        window.scrollTo({
            top: violation.offsetTop,
            // behavior: "smooth",
        });
    }, []);

    return (
                  
            <section id="grantsManagement" className="grants-management-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6 col-lg-6" data-aos="zoom-out-right">
                            <h3 className="h1">
                                Grants Management through Automation
                            </h3>
                            <p>A straightforward and relatively low-cost grant management software for nonprofits that
                                delivers a distraction-free open user environment to encourage collaboration, learning, and
                                best practice sharing. It provides comprehensive services to support and enhance the success
                                of mission-driven organizations to drive deeper donor engagement, unparalleled
                                organizational efficiency, increased funding and more time devoted to the advancement of
                                your cause. </p>
                        </div>
                        <div className="col-md-6 col-lg-6 mt-xs-3">
                            <div className="cubeContent_wrapper">
                                <div className="dotBg"> </div>
                                <div className="blueCube"></div>
                                <div className="greenCube"></div>
                                <img alt="grant management software for nonprofits" src={gmbanner} width="595" height="645" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
       
    )
}

export default GrantsManagement